import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { OrdensFinalizadas } from './pages/OrdensFinalizadas';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<Login />} />
          <Route element={<ProtectedRoute redirectTo="/" />}>
              
                <Route path={"/main"} element={<Dashboard />} />
                <Route path={"/finalizadas"} element={<OrdensFinalizadas />} />

          </Route>
  
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster 
          position="top-center"
          richColors
          closeButton
          toastOptions={{
            style: {
              fontSize: '14px',
              padding: '12px 16px',
              maxWidth: '90vw',
              wordBreak: 'break-word',
            },
          }}
        />
      </BrowserRouter>
  );
}

export default App;

